import React, { Component } from 'react'
import './index.css'
import { Layout, Affix, Button, Icon, Anchor } from 'antd';
import { withTranslation } from 'react-i18next';
const { Content } = Layout;
class PolicyCN extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // top: 85,
            // bottom: 10,
            // offsetTop: 80
        };
    }
    render() {
        const { t } = this.props
        return (
            <Content className="q-content-wrapper">
                <div className="q-main " style={{ padding: '65px 0 20px 0px' }}>
                    <Content className="q-detail-content q-policy" >
                    <div className="right-content" id="soft-introduce">
                        <h2>{t('policyTitle')}</h2>
                        <div className="right-content-box" >
                            <p>{t('policyContent')}</p>
                            <p>{t('policyContent_1')}</p>
                            <p>{t('policyContent_2')}</p>
                            <p>{t('policyContent_3')}</p>
                        </div>
                        <div className="right-content-box" >
                            <ul> 
                                <p><b>{t('policyContent_31')}</b></p>
                                <p><b>{t('policyContent_32')}</b></p>
                                <p><b>{t('policyContent_33')}</b></p>
                                <p><b>{t('policyContent_34')}</b></p>
                                <p><b>{t('policyContent_35')}</b></p>
                                <p><b>{t('policyContent_36')}</b></p>
                                <p><b>{t('policyContent_37')}</b></p>
                                <p><b>{t('policyContent_38')}</b></p>
                                <p><b>{t('policyContent_39')}</b></p>
                                <p><b>{t('policyContent_310')}</b></p>
                                <p><b>{t('policyContent_311')}</b></p>
                                <p><b>{t('policyContent_312')}</b></p>
                                <p><b>{t('policyContent_313')}</b></p>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyItem01')}</h4>
                            <ul> 
                                <p>{t('policyItem01_1')}</p>
                                <p>{t('policyItem01_2')}</p>
                                <p>{t('policyItem01_3')}</p>
                                <p>{t('policyItem01_4')}</p>
                                <p>{t('policyItem01_5')}</p>
                                <p>{t('policyItem01_6')}</p>
                                <p>{t('policyItem01_7')}</p>
                                <p>{t('policyItem01_8')}</p>
                                <p>{t('policyItem01_9')}</p>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyItem02')}</h4>
                            <ul> 
                                <p>{t('policyItem02_1')}</p>
                                <p>{t('policyItem02_2')}</p>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyItem03')}</h4>
                            <ul> 
                                <p>{t('policyItem03_0')}</p>
                                <p>{t('policyItem03_01')}</p>
                                <p>{t('policyItem03_02')}</p>
                                <p>{t('policyItem03_1')}</p>
                                <ul>
                                    <p>{t('policyItem03_11')}</p>
                                    <p>{t('policyItem03_12')}</p>
                                    <p>{t('policyItem03_13')}</p>
                                    <p>{t('policyItem03_14')}</p>
                                    <p>{t('policyItem03_15')}</p>
                                    <p>{t('policyItem03_16')}</p>
                                </ul>
                                <p>{t('policyItem03_2')}</p>
                                <p>{t('policyItem03_20')}</p>
                                <ul>
                                    <p>{t('policyItem03_21')}</p>
                                    <ul>
                                        <p>{t('policyItem03_210')}</p>
                                        <p>{t('policyItem03_211')}</p>
                                        <p>{t('policyItem03_212')}</p>
                                    </ul>
                                    <p>{t('policyItem03_22')}</p>
                                    <ul>
                                        <p>{t('policyItem03_220')}</p>
                                        <p>{t('policyItem03_221')}</p>
                                    </ul>
                                </ul>
                                <p>{t('policyItem03_3')}</p>
                                <ul>
                                    <p>{t('policyItem03_31')}</p>
                                    <p>{t('policyItem03_33')}</p>
                                    <p>{t('policyItem03_34')}</p>
                                    <p>{t('policyItem03_35')}</p>
                                </ul>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyItem04')}</h4>
                            <ul> 
                                <p>{t('policyItem04_1')}</p>
                                <ul>
                                    <p>{t('policyItem04_11')}</p>
                                    <p>{t('policyItem04_12')}</p>
                                    <p>{t('policyItem04_13')}</p>
                                    <p>{t('policyItem04_14')}</p>
                                    <p>{t('policyItem04_15')}</p>
                                </ul>
                                <p>{t('policyItem04_2')}</p>
                                <ul>
                                    <p>{t('policyItem04_20')}</p>
                                    <p>{t('policyItem04_21')}</p>
                                    <p>{t('policyItem04_22')}</p>
                                </ul>
                                <p>{t('policyItem04_3')}</p>
                                <p>{t('policyItem04_30')}</p>
                                <ul>
                                    <p>{t('policyItem04_31')}</p>
                                    <p>{t('policyItem04_32')}</p>
                                </ul>
                                <p>{t('policyItem04_4')}</p>
                                <ul>
                                    <p>{t('policyItem04_41')}</p>
                                    <p>{t('policyItem04_42')}</p>
                                    <p>{t('policyItem04_43')}</p>
                                    <p>{t('policyItem04_44')}</p>
                                    <p>{t('policyItem04_45')}</p>
                                    <p>{t('policyItem04_46')}</p>
                                </ul>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyItem05')}</h4>
                            <ul>
                                <p>{t('policyItem05_0')}</p>
                                <p>{t('policyItem05_1')}</p>
                                <ul>
                                    <p>{t('policyItem05_11')}</p>
                                    <p>{t('policyItem05_12')}</p>
                                    <p>{t('policyItem05_13')}</p>
                                </ul>
                                <p>{t('policyItem05_2')}</p>
                                <ul>
                                    <p>{t('policyItem05_21')}</p>
                                    <p>{t('policyItem05_22')}</p>
                                </ul>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyItem06')}</h4>
                            <ul>
                                <p>{t('policyItem06_1')}</p>
                                <p>{t('policyItem06_2')}</p>
                                <ul>
                                    <p>{t('policyItem06_21')}</p>
                                    <p>{t('policyItem06_22')}</p>
                                    <p>{t('policyItem06_23')}</p>
                                    <p>{t('policyItem06_24')}</p>
                                </ul>
                                <p>{t('policyItem06_3')}</p>
                                <p>{t('policyItem06_4')}</p>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyItem07')}</h4>
                            <ul>
                                <p>{t('policyItem07_1')}</p>
                                <p>{t('policyItem07_2')}</p>
                                <p>{t('policyItem07_2')}</p>
                                <p>{t('policyItem07_3')}</p>
                                <p>{t('policyItem07_4')}</p>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyItem08')}</h4>
                            <ul>
                                <p>{t('policyItem08_1')}</p>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyItem09')}</h4>
                            <ul>
                                <p>{t('policyItem09_1')}</p>
                                <p>{t('policyItem09_2')}</p>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyItem10')}</h4>
                            <ul>
                                <p>{t('policyItem10_1')}</p>
                                <p>{t('policyItem10_2')}</p>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyItem11')}</h4>
                            <ul>
                                <p>{t('policyItem11_1')}</p>
                                <p>{t('policyItem11_11')}</p>
                                <p>{t('policyItem11_2')}</p>
                                <p>{t('policyItem11_20')}</p>
                                <ul>
                                    <p>{t('policyItem11_21')}</p>
                                    <p>{t('policyItem11_22')}</p>
                                    <p>{t('policyItem11_23')}</p>
                                </ul>
                                <p>{t('policyItem11_3')}</p>
                                <ul>
                                    <p>{t('policyItem11_31')}</p>
                                </ul>
                                <p>{t('policyItem11_4')}</p>
                                <ul>
                                    <p>{t('policyItem11_41')}</p>
                                </ul>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyItem12')}</h4>
                            <ul>
                                <p>{t('policyItem12_1')}</p>
                            </ul>
                        </div>
                        <div className="right-content-box" >
                            <h4>{t('policyItem13')}</h4>
                            <ul>
                                <p>{t('policyItem13_1')}</p>
                                <p>{t('policyItem13_2')}</p>
                            </ul>
                        </div>
                    </div>
                   </Content>
                </div>
            </Content>
        )
    }
}
export default withTranslation()(PolicyCN)